<template>
  <a-modal
    v-model="visible"
    :title="title || modalTitle"
    :destroy-on-close="true"
    :footer="null"
    wrap-class-name="fullscreen-modal"
    dialog-class="answer-modal"
    width="1000px"
    :after-close="afterClose"
  >
    <div class="modal-content">
      <div class="answer-overall">
        <div
          :class="[
            'answer-score',
            textEvaluate.result.scoreRate >= 85
              ? 'col-1DC060'
              : textEvaluate.result.scoreRate >= 60
                ? 'col-FFA516'
                : 'col-FF3C30'
          ]"
        >
          <span class="score">{{ Number(textEvaluate.result.overall).toFixed(2) }}</span>
          <span class="text">分</span>
        </div>
        <div class="answer-star">
          <template v-for="index in 5">
            <img
              :key="index"
              class="answer-star-img"
              :src="
                index <= fetchStarNum(textEvaluate.result.scoreRate)
                  ? require('@/assets/common/star_highlight.png')
                  : require('@/assets/common/star_grey.png')
              "
              alt=""
            />
          </template>
        </div>
      </div>
      <div v-if="textEvaluate?.result?.choiceResult?.choiceList" class="answer-evaluate">
        <div v-for="s in textEvaluate.result.choiceResult.choiceList" :key="s.id" class="choice-item">
          <div class="text-title" v-html="s.text" />
          <div class="choice-option">
            <div v-for="option in s.optionsTypeList" :key="option.id || option.text" class="option-item">
              <img
                v-if="option.answer"
                class="radio-icon"
                :src="require('@/assets/common/solid_correct.png')"
                alt="img"
              />
              <img
                v-else-if="option.isChoice"
                class="radio-icon"
                :src="require('@/assets/common/solid_error2.png')"
                alt="img"
              />
              <img
                v-else
                class="radio-icon mr-10"
                :src="require('@/assets/common/circle_selected_grey.png')"
                alt="img"
              />
              <span class="option-text" v-html="option.text" />
              <span v-if="option.fileUrl" class="showTxt-img">
                <img :src="option.fileUrl" alt="img" />
              </span>
            </div>
            <span v-if="!handleOption(s.optionsTypeList)" class="no-answer-text">(未作答)</span>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
// 课文听读、教辅、本地专版评测弹框--选择类型弹框
export default {
  name: 'ChoiceEvaluateModel',
  data() {
    return {
      visible: false,
      title: '',
      textEvaluate: {
        result: {
          overall: 0
        },
        audioUrl: ''
      },
      onClose: null
    }
  },
  computed: {
    modalTitle() {
      return this.$store.getters.activeAnswer && this.$store.getters.activeAnswer.id
        ? (this.$store.getters.activeAnswer.realName || this.$store.getters.activeAnswer.name) + '的作答详情'
        : '作答详情'
    }
  },
  methods: {
    changeVisible(bol) {
      this.visible = bol
    },
    // 获取得分星星数量
    fetchStarNum(overall) {
      overall = Number(overall)
      if (overall >= 80) {
        return 5
      } else if (overall >= 60) {
        return 4
      } else if (overall >= 40) {
        return 3
      } else if (overall >= 20) {
        return 2
      } else {
        return 1
      }
    },
    afterClose() {
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    handleOption(data) {
      const index = data.findIndex(el => el.isChoice)
      return index > -1
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal {
  &.answer-modal {
    .ant-modal-content {
      border-radius: 24px;
      .ant-modal-header {
        height: 72px;
        background: url('@/assets/common/model_title.png');
        background-size: 100% 72px;
        border-radius: 24px 24px 0 0;
        padding: 22px 40px;
        .ant-modal-title {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          font-weight: bold;
        }
      }
      .ant-modal-close {
        top: 14px;
        right: 14px;
        .ant-modal-close-x {
          width: 44px;
          height: 44px;
          line-height: 44px;
        }
      }
      .ant-modal-body {
        border-radius: 0 0 24px 24px;
        padding: 0;
        max-height: calc(100vh - 312px);
        padding-bottom: 28px;
        overflow-y: auto;
        .modal-content {
          .answer-overall {
            width: 330px;
            //height: 202px;
            padding: 20px 0;
            margin: 0 auto;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            .answer-score {
              display: flex;
              align-items: center;
              .score {
                font-size: 34px;
              }
              .text {
                margin-left: 4px;
                font-size: 18px;
              }
            }
            .answer-star {
              margin-bottom: 20px;
              .answer-star-img {
                width: 16px;
                height: 16px;
                & + .answer-star-img {
                  margin-left: 4px;
                }
              }
            }
          }
          .answer-evaluate {
            display: flex;
            flex-flow: column;
            //justify-content: center;
            //align-items: center;
            padding: 0 40px;
            //margin-bottom: 70px;
            .text-title {
              font-size: 20px;
              line-height: 28px;
              color: #333333;
            }
            .choice-option {
              display: flex;
              align-items: center;
              .option-item {
                & + .option-item {
                  margin-left: 60px;
                }
                .radio-icon {
                  width: 20px;
                  height: 20px;
                }
                .option-text {
                  font-size: 20px;
                  line-height: 28px;
                  color: #333333;
                }
                .showTxt-img {
                  display: inline-block;
                  width: 122px;
                  height: 122px;
                  line-height: 122px;
                  margin-bottom: 10px;
                  text-align: center;

                  img {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                  }
                }
              }
              .no-answer-text {
                font-size: 15px;
                line-height: 21px;
                color: #1976ff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
